module.exports = __webpack_public_path__ + "img/step-2.bc8724b8.jpg";